<button type="button" role="switch" class="toggle-switch" [class.toggle-switch--on]="checked"
  [attr.id]="inputId" [attr.aria-checked]="checked" [attr.aria-labelledby]="labelledBy"
  [attr.aria-describedby]="describedBy" [disabled]="disabled" (click)="toggle()" (blur)="onBlur()">
  <span class="toggle-switch__thumb" aria-hidden="true"></span>
</button>
